export enum PageRoute {
  START = '/',
  SIGNIN = '/signin',
  SIGNIN_VERIFICATION = '/signinVerification',
  SIGNUP = '/signup',
  DOCUMENTS = '/documents',
  SINGLE_DOCUMENT = '/singledocument',
  CREATE_DOCUMENT = '/createdocument',
  UPDATE_DOCUMENT = '/updatedocument',
  ACCOUNT = '/account',
  WHITELIST = '/account/whitelist',
  RESET_PASSWORD = '/resetpassword',
  SET_NEW_PASSWORD = '/setnewpassword',
  VERIFICATION = '/verification',
}

export enum StackRoute {
  START = '/',
}
